export const MODULE_PREFIX = 'form';

export const DEBOUNCE_INTERVAL = 1000;
